export const environment = {
    ENV: 'production',

    API_URL: 'https://mobibus-gateway.fleetaware.pt',

    keycloakConfig: {
        url: 'https://mobibus-auth.fleetaware.pt'
    }
};
